import { type FC, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { ListGroup } from 'react-bootstrap';
import { BsArrowUp, BsArrowDown, BsTrash } from 'react-icons/bs';
import { dropdownStyle, rowDropdownStyle } from './styles';

interface Props {
	coords: any;
	index: number;
	onAddRowClick: (_) => void;
	onDeleteRowClick: (_) => void;
	onClickOutside: () => void;
}

const RowOptionsDropdown: FC<Props> = (props) => {
	const { coords, index, onAddRowClick, onDeleteRowClick, onClickOutside } = props;

	const ref = useRef(null);

	const onAddRowAbove = (index: number) => {
		onAddRowClick(index);
		onClickOutside();
	};

	const onAddRowBelow = (index: number) => {
		onAddRowClick(index + 1);
		onClickOutside();
	};

	const onDeleteRow = (index: number) => {
		// eslint-disable-next-line no-alert
		if (window.confirm(`Are you sure to delete the row ?`)) {
			onDeleteRowClick(index);
		}
		onClickOutside();
	};

	const handleClickOutside = (event) => {
		if (ref.current && !ref.current.contains(event.target)) {
			onClickOutside();
		}
	};

	useEffect(() => {
		document.addEventListener('click', handleClickOutside, true);
		return () => {
			document.removeEventListener('click', handleClickOutside, true);
		};
	});

	return ReactDOM.createPortal(
		<ListGroup
			className={`${dropdownStyle} ${rowDropdownStyle}`}
			style={{ top: coords.top, left: coords.left }}
			ref={ref}>
			<ListGroup.Item className="dropdownItem" onClick={() => onAddRowAbove(index)}>
				<BsArrowUp /> <span>Add row above</span>
			</ListGroup.Item>

			<ListGroup.Item className="dropdownItem" onClick={() => onAddRowBelow(index)}>
				<BsArrowDown /> <span>Add row below</span>
			</ListGroup.Item>

			<ListGroup.Item
				className="dropdownItem deleteDropdownItem"
				onClick={() => onDeleteRow(index)}>
				<BsTrash /> <span>Delete row</span>
			</ListGroup.Item>
		</ListGroup>,
		document.querySelector('#editor2-portal-root')
	);
};

export default RowOptionsDropdown;
